import request from '@/utils/request'
//get
export function getDocumentByParam(param) {
  return request({
    url: `/document/${param}`,
    method: 'GET'
  })
}
export function createDocument(data) {
  return request({
    url: `/document/`,
    method: 'POST',
    data
  })
}

export function readDocument(id) {
  return request({
    url: `/document/${id}/`,
    method: 'GET'
  })
}


export function updateDocument(data,id){
  return request({
    url: `/document/${id}/`,
    method: 'PATCH',
    data
  })
}

export function deleteDocument(id) {
  return request({
    url: `/document/${id}/`,
    method: 'DELETE'
  })
}


// WEBPACK FOOTER //
// ./src/api/document.js